export default "__VITE_ASSET__BX_3r_MG__"